import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import {
  Drawer,
  List as MuiList,
  ListItem,
  ListItemText,
  Collapse,
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import styled from 'styled-components';

const Div = styled.div`
  width: 300px;
`;

const List = styled(MuiList)`
  width: 300px;
`;

const NestedListItem = styled(ListItem)`
  padding-left: 2rem;
  color: black;
`;

const Navigation = ({ state, toggleDrawer }) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const data = useStaticQuery(graphql`
    {
      sanitySettings {
        navigation {
          items {
            link {
              linkName
              page {
                ... on SanityAboutPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityContactPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityCustomPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityLandingPage {
                  id
                  name
                }
                ... on SanityServicesPage {
                  id
                  name
                  slug {
                    current
                  }
                }
              }
            }
            childLinks {
              page {
                ... on SanityAboutPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityContactPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityCustomPage {
                  id
                  name
                  slug {
                    current
                  }
                }
                ... on SanityLandingPage {
                  id
                  name
                }
                ... on SanityServicesPage {
                  id
                  name
                  slug {
                    current
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const navigationItems = data.sanitySettings.navigation.items;

  const list = () => (
    <Div role="presentation">
      <List>
        {navigationItems.map((item, index) =>
          item.link.page ? (
            <React.Fragment key={index}>
              <ListItem
                button
                onClick={toggleDrawer}
                onKeyDown={toggleDrawer}
                component={Link}
                to={
                  item.link.page.slug != null
                    ? `/${item.link.page.slug.current}`
                    : '/'
                }
              >
                <ListItemText
                  primary={item.link.linkName}
                  primaryTypographyProps={{ color: 'primary', variant: 'h5' }}
                />
              </ListItem>
              {item.childLinks.length > 0 ? (
                <List component="div" disablePadding>
                  {item.childLinks.map((child, index) =>
                    child.page ? (
                      <NestedListItem
                        button
                        key={index}
                        onClick={toggleDrawer}
                        onKeyDown={toggleDrawer}
                        component={Link}
                        to={
                          child.page.slug != null
                            ? `/${child.page.slug.current}`
                            : '/'
                        }
                      >
                        <ListItemText primary={child.page.name} />
                      </NestedListItem>
                    ) : (
                      ''
                    )
                  )}
                </List>
              ) : (
                ''
              )}
            </React.Fragment>
          ) : (
            <div key={index}>
              <ListItem button onClick={handleClick}>
                <ListItemText
                  primary={item.link.linkName}
                  primaryTypographyProps={{ color: 'primary', variant: 'h5' }}
                />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {item.childLinks.map((child, index) =>
                    child.page ? (
                      <NestedListItem
                        button
                        color="primary"
                        key={index}
                        onClick={toggleDrawer}
                        onKeyDown={toggleDrawer}
                        component={Link}
                        to={
                          child.page.slug != null
                            ? `/${child.page.slug.current}`
                            : '/'
                        }
                      >
                        <ListItemText primary={child.linkName} />
                      </NestedListItem>
                    ) : (
                      ''
                    )
                  )}
                </List>
              </Collapse>
            </div>
          )
        )}
      </List>
    </Div>
  );

  return (
    <div>
      <Drawer anchor="right" open={state} onClose={toggleDrawer}>
        {list()}
      </Drawer>
    </div>
  );
};
export default Navigation;
